import React, { useEffect, useState } from "react";
import { FaBuilding, FaMapMarkerAlt, FaEnvelope, FaSave, FaTimes } from "react-icons/fa";
import styles from "../../styles/office/OfficeProfile.module.css";

const OfficeProfile = ({ onClose }) => {
    const [formData, setFormData] = useState({
        officeName: "",
        division: "",
        district: "",
        taluka: "",
        village: "",
        email: "",
        profile: "",            // new column
        stamp_path: "",         // new column
        signature_path: ""      // new column
    });

    const [isSaving, setIsSaving] = useState(false);
    const token = localStorage.getItem("token_office");

    useEffect(() => {
        const getProfile = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_office_profile.php`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    credentials: 'include'
                });

                const result = await response.json();

                if (result.status === "success") {
                    setFormData({
                        officeName: result.profile.office_name || "",
                        division: 'Pune' || "",
                        district: 'Sangli' || "",
                        taluka: 'Sangli' || "",
                        village: result.profile.city || "",
                        email: result.profile.email || "",
                        profile: result.profile.profile || "", // backend column
                        stamp_path: result.profile.stamp_path || "",
                        signature_path: result.profile.signature_path || ""
                    });
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

        getProfile();
    }, [token]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData({ ...formData, [name]: files[0] });
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setIsSaving(true);

        try {
            const formDataToSend = new FormData();
            Object.keys(formData).forEach(key => {
                formDataToSend.append(key, formData[key]);
            });

            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/officeProfileUpdate.php`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    body: formDataToSend,
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                onClose();
            } else {
                console.error("Error updating profile:", result.message);
            }
        } catch (error) {
            console.error("Error updating profile:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const isAuthorizer = formData.profile?.toLowerCase() === "authorizer";

    return (
        <div className={styles.overlay}>
            <div className={styles.profileContainer}>
                <div className={styles.header}>
                    <h2 className={styles.heading}>
                        <FaBuilding className={styles.headerIcon} />
                        Office Profile
                    </h2>
                    <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
                        <FaTimes />
                    </button>
                </div>

                <form onSubmit={handleSave} className={styles.profileForm}>
                    <div className={styles.twoColumnLayout}>
                        {/* Office Information Column */}
                        <div className={styles.formColumn}>
                            <div className={styles.section}>
                                <h3 className={styles.sectionTitle}>
                                    <FaBuilding className={styles.sectionIcon} />
                                    Office Details
                                </h3>

                                <div className={styles.formGroup}>
                                    <label htmlFor="officeName">Office Name</label>
                                    <input
                                        type="text"
                                        id="officeName"
                                        name="officeName"
                                        value={formData.officeName}
                                        onChange={handleChange}
                                        className={styles.inputField}
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="email">Email</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className={styles.inputField}
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label>Profile Role</label>
                                    <input
                                        type="text"
                                        name="profile"
                                        value={formData.profile}
                                        readOnly
                                        className={styles.inputField}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Location Information Column */}
                        <div className={styles.formColumn}>
                            <div className={styles.section}>
                                <h3 className={styles.sectionTitle}>
                                    <FaMapMarkerAlt className={styles.sectionIcon} />
                                    Location Details
                                </h3>

                                <div className={styles.formGroup}>
                                    <label htmlFor="division">Division</label>
                                    <input
                                        type="text"
                                        id="division"
                                        name="division"
                                        value={formData.division}
                                        onChange={handleChange}
                                        className={styles.inputField}
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="district">District</label>
                                    <input
                                        type="text"
                                        id="district"
                                        name="district"
                                        value={formData.district}
                                        onChange={handleChange}
                                        className={styles.inputField}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stamp & Signature (Only for Authorizer) */}
                    {isAuthorizer && (
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>Authorization Details</h3>

                            <div className={styles.formGroup}>
                                <label>Current Stamp</label>
                                {/* {formData.stamp_path ? (
                                    // <img
                                    //     src={`${process.env.REACT_APP_SERVER_URL}/${formData.stamp_path}`}
                                    //     alt="Stamp"
                                    //     style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    // />

                                    <img
                                        src={`${process.env.REACT_APP_SERVER_URL}/get_image.php?file=${formData.stamp_path.split('/').pop()}`}
                                        alt="Stamp"
                                        style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    />
                                ) : (
                                    <p>No stamp uploaded</p>
                                )} */}


                                {formData.stamp_path ? (
                                    <img
                                        src={`${process.env.REACT_APP_SERVER_URL}/get_image.php?file=${formData.stamp_path}`}
                                        alt="Stamp"
                                        style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    />
                                ) : (
                                    <p>No stamp uploaded</p>
                                )}

                                <input
                                    type="file"
                                    name="stamp_path"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label>Current Signature</label>
                                {/* {formData.signature_path ? (
                                    // <img
                                    //     src={`${process.env.REACT_APP_SERVER_URL}/${formData.signature_path}`}
                                    //     alt="Signature"
                                    //     style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    // />

                                    <img
                                        src={`${process.env.REACT_APP_SERVER_URL}/get_image.php?file=${formData.signature_path.split('/').pop()}`}
                                        alt="Signature"
                                        style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    />

                                ) : (
                                    <p>No signature uploaded</p>
                                )} */}

                                {formData.signature_path ? (
                                    <img
                                        src={`${process.env.REACT_APP_SERVER_URL}/get_image.php?file=${formData.signature_path}`}
                                        alt="Signature"
                                        style={{ maxWidth: "150px", marginBottom: "10px" }}
                                    />
                                ) : (
                                    <p>No signature uploaded</p>
                                )}

                                <input
                                    type="file"
                                    name="signature_path"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>
                    )}

                    <div className={styles.formActions}>
                        <button
                            type="button"
                            className={styles.cancelButton}
                            onClick={onClose}
                            disabled={isSaving}
                        >
                            <FaTimes className={styles.buttonIcon} />
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={styles.saveButton}
                            disabled={isSaving}
                        >
                            {isSaving ? (
                                <span className={styles.spinner}></span>
                            ) : (
                                <>
                                    <FaSave className={styles.buttonIcon} />
                                    Save Changes
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OfficeProfile;
